import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const KitContext = createContext(null);

export const KitProvider = ({ children }) => {
  const { user } = useAuth();
  const storageKey = user ? `swag-kit:${user.email}` : null;
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!storageKey) {
      setItems([]);
      return;
    }
    try {
      setItems(JSON.parse(localStorage.getItem(storageKey)) || []);
    } catch {
      setItems([]);
    }
  }, [storageKey]);

  const save = (next) => {
    setItems(next);
    if (!storageKey) return;
    try {
      localStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
      localStorage.removeItem(storageKey);
    }
  };

  const add = (item) => save([...items, { ...item, key: `${Date.now()}-${Math.random()}` }]);
  const remove = (key) => save(items.filter((i) => i.key !== key));
  const clear = () => save([]);
  const sync = (products) => {
    const byId = Object.fromEntries(products.map((p) => [p.id, p]));
    const next = items.filter((i) => byId[i.product_id]).map((i) => {
      const p = byId[i.product_id];
      return { ...i, points: p.points, name: p.name, image: p.image };
    });
    if (JSON.stringify(next) !== JSON.stringify(items)) save(next);
  };
  const total = items.reduce((s, i) => s + i.points, 0);

  return (
    <KitContext.Provider value={{ items, add, remove, clear, total, sync }}>{children}</KitContext.Provider>
  );
};

export const useKit = () => useContext(KitContext);
